import { PropsWithChildren } from "react";

export const CardGrid: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="card-grid-container">
      <div className="card-grid">{children}</div>
    </div>
  );
};
